module.exports = __webpack_public_path__ + "img/safety.1fd8344e.svg";